// Footer — persistent disclaimer microcopy (F8.3, PSD §10.1). Presentation.

import { DISCLOSURE } from './disclaimer';

export function Footer() {
  return (
    <footer className="footer app-footer">
      <p className="footer-disclaimer">{DISCLOSURE}</p>
    </footer>
  );
}
